import { render, staticRenderFns } from "./HistoryStudiesTable.vue?vue&type=template&id=5240ee7b&"
import script from "./HistoryStudiesTable.vue?vue&type=script&lang=js&"
export * from "./HistoryStudiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports